import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/cn";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: Array<{ value: string; label: string }>;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, options, ...props }, ref) => {
    return (
      <div className="relative">
        <select
          ref={ref}
          className={cn(
            "h-9 w-full bg-surface-2 text-text-primary",
            "border border-border rounded-md px-3 pr-8 text-sm font-sans",
            "appearance-none cursor-pointer",
            "transition-shadow duration-150",
            "focus:outline-none focus:border-magenta focus:shadow-focus",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            className,
          )}
          {...props}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value} className="bg-surface-1 text-text-primary">
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDown
          className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-text-muted"
          size={14}
        />
      </div>
    );
  },
);
Select.displayName = "Select";
